import AndroidIcon from '@mui/icons-material/AndroidRounded';
import AppleIcon from '@mui/icons-material/Apple';
import WebIcon from '@mui/icons-material/LanguageRounded';
import { Chip, chipClasses } from '@mui/material';
import type { ReactElement } from 'react';
import { ApplicationType } from '../../model/types';

export const APPLICATION_TYPE_LABEL_MAP: Record<ApplicationType, string> = {
  [ApplicationType.web]: 'Web Application',
  [ApplicationType.android]: 'Google Play',
  [ApplicationType.ios]: 'App Store',
};

export const APPLICATION_TYPE_ICON_MAP: Record<ApplicationType, ReactElement> =
  {
    [ApplicationType.web]: <WebIcon />,
    [ApplicationType.android]: <AndroidIcon />,
    [ApplicationType.ios]: <AppleIcon />,
  };

interface Props {
  applicationType: ApplicationType;
}

export function ApplicationTypeChip({ applicationType }: Props) {
  return (
    <Chip
      sx={{ borderRadius: 2, [`& .${chipClasses.label}`]: { pr: 1 } }}
      avatar={APPLICATION_TYPE_ICON_MAP[applicationType]}
      label={APPLICATION_TYPE_LABEL_MAP[applicationType]}
    />
  );
}
